
export default function detectAndroid(){
    return navigator.userAgent.includes('Android')
}